module.exports = __webpack_public_path__ + "static/media/ios-color-filter.80481394.svg";